import { millsToTimeString } from 'src/helpers/date-helpers';
import { ExpressionNodeType } from './expression/types';
import { FormFieldOption, isFieldWithOptions } from '../../../types/BaseControlTypes';
import { getTimeInputOptions } from 'src/features/generalForms/uikit/fields/time/timePickerOptions';

type BuilderNodeLookupResult = {
  data: {
    props?: unknown;
    name?: string;
  };
};

type GetNodeByDataKey = (dataKey: string) => BuilderNodeLookupResult | undefined;

export const getConditionalInvalidValuesError = (
  node: ExpressionNodeType,
  getNodeByDataKey: GetNodeByDataKey,
  getMissingValuesText: (values: string) => string,
) => {
  const nodeData = getNodeByDataKey(node.dataKey)?.data;
  const prop = nodeData?.props;
  const resolvedName = nodeData?.name;
  const isTimeInput = resolvedName === 'FormTimeInput';
  const withOptions = isFieldWithOptions(prop);

  if (!isTimeInput && !withOptions) return undefined;

  const optionEntries: { key: string; value: string }[] = isTimeInput
    ? getTimeInputOptions((prop as { timeIntervalInMinutes?: number } | undefined)?.timeIntervalInMinutes).map(
        (option) => ({
          key: String(option.key),
          value: option.text ?? String(option.key),
        }),
      )
    : ((prop as { options?: FormFieldOption[] } | undefined)?.options ?? []).map((option) => ({
        key: String(option.key),
        value: option.value,
      }));

  const optionKeys = optionEntries.map((option) => option.key);

  const values = Array.isArray(node.value) ? node.value : [node.value];
  const invalidValues = values
    .filter((value) => value !== null && value !== undefined && value !== '')
    .filter((value) => !optionKeys.includes(String(value)));

  if (!invalidValues.length) return undefined;

  const invalidValuesText = invalidValues
    .map((value) => {
      if (!isTimeInput) return String(value);

      const valueInMills = Number(value);

      return Number.isNaN(valueInMills) ? String(value) : millsToTimeString(valueInMills);
    })
    .join(', ');

  return getMissingValuesText(invalidValuesText);
};
